/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The GameControllerDtoConfigItemListConfigItemData model module.
 * @module model/GameControllerDtoConfigItemListConfigItemData
 * @version 1.0
 */
class GameControllerDtoConfigItemListConfigItemData {
    /**
     * Constructs a new <code>GameControllerDtoConfigItemListConfigItemData</code>.
     * @alias module:model/GameControllerDtoConfigItemListConfigItemData
     */
    constructor() { 
        
        GameControllerDtoConfigItemListConfigItemData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>GameControllerDtoConfigItemListConfigItemData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/GameControllerDtoConfigItemListConfigItemData} obj Optional instance to populate.
     * @return {module:model/GameControllerDtoConfigItemListConfigItemData} The populated <code>GameControllerDtoConfigItemListConfigItemData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GameControllerDtoConfigItemListConfigItemData();

            if (data.hasOwnProperty('itemId')) {
                obj['itemId'] = ApiClient.convertToType(data['itemId'], 'Number');
            }
            if (data.hasOwnProperty('itemName')) {
                obj['itemName'] = ApiClient.convertToType(data['itemName'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>GameControllerDtoConfigItemListConfigItemData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>GameControllerDtoConfigItemListConfigItemData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['itemName'] && !(typeof data['itemName'] === 'string' || data['itemName'] instanceof String)) {
            throw new Error("Expected the field `itemName` to be a primitive type in the JSON string but got " + data['itemName']);
        }

        return true;
    }


}



/**
 * @member {Number} itemId
 */
GameControllerDtoConfigItemListConfigItemData.prototype['itemId'] = undefined;

/**
 * @member {String} itemName
 */
GameControllerDtoConfigItemListConfigItemData.prototype['itemName'] = undefined;






export default GameControllerDtoConfigItemListConfigItemData;

